import React from "react";
import {
  AppstoreOutlined,
  DollarOutlined,
  LaptopOutlined,
  MailOutlined,
  PhoneOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  UserOutlined,
    FieldTimeOutlined
} from "@ant-design/icons";

import { Permissions } from "../scripts/settings";

// account
import AccountLayout from "../layouts/Account";
import LoginPage from "../pages/Login";

// app
import BasicLayout from "../layouts/Basic";

import DashboardPage from "../pages/Dashboard";

import SettingsPage from "../pages/Settings";
import UsersPage from "../pages/Users";
import SocialNetwork from "../pages/SocialNetwork";
import Slider from "../pages/Slider";
import UserJobs from "../pages/UserJobs";


// errors
import NotFoundPage from "../pages/NotFound";
import UnAuthorizedPage from "../pages/UnAuthorized";

import Resources from "./resources";
import Category from "../pages/Category";
import Product from "../pages/Product";
import Color from "../pages/Color";
import Size from "../pages/Size";
import ProductManagement from "../pages/ProductManagement";
import PRType from "../pages/PRType";

export default [
  // errors
  {
    path: "/403",
    name: "unauthorized",
    component: UnAuthorizedPage,
  },
  {
    path: "/404",
    name: "notfound",
    component: NotFoundPage,
  },
  // account
  {
    path: "/account",
    name: "account",
    component: AccountLayout,
    routes: [
      {
        path: "/account",
        redirect: "/account/login",
      },
      {
        path: "/account/logout",
        redirect: "/account/login",
      },
      {
        path: "/account/login",
        name: "login",
        title: Resources.login,
        component: LoginPage,
      },
    ],
  },
  // app
  {
    path: "/",
    name: "app",
    component: BasicLayout,
    routes: [
      {
        name: "dashboardRedirect",
        path: "/",
        redirect: "/dashboard",
        hidden: true,
      },
      {
        name: "dashboard",
        icon: <LaptopOutlined />,
        path: "/dashboard",
        title: Resources.dashboard,
        component: DashboardPage,
      },
      {
        name: "users",
        icon: <UserOutlined />,
        path: "/users",
        title: Resources.users,
        component: UsersPage,
      },
      // {
      //   name: "deliveryTimes",
      //   icon: <FieldTimeOutlined />,
      //   path: "/deliveryTimes",
      //   title: Resources.deliveryTime,
      //   component: DeliveryTime,
      // },

      // {
      //   name: "discount",
      //   icon: <DollarOutlined />,
      //   path: "/discount",
      //   title: Resources.discountCode,
      //   component: Discount,
      // },
      // {
      //   name: "orders",
      //   icon: <ShoppingCartOutlined />,
      //   path: "/orders",
      //   title: Resources.orders,
      //   component: OrdersPage,
      // },
      {
        name: "category",
        icon: <AppstoreOutlined />,
        path: "/categories",
        title: Resources.category,
        component: Category,
      },

      {
        name: "products",
        icon: <ShoppingOutlined />,
        path: "/products",
        title: Resources.allProducts,
        component: Product,
      },

      {
        name: "productManagement",
        icon: <ShoppingOutlined />,
        path: "/productManagement",
        title: Resources.products,
        component: ProductManagement,
      },
  
      
      // {
      //   name: "messages",
      //   icon: <MailOutlined />,
      //   path: "/messages",
      //   title: Resources.messages,
      //   component: MessagesPage,
      //   authority: Permissions.message_list,
      // },
      {
        name: "settings",
        icon: <SettingOutlined />,
        path: "/settings",
        title: Resources.settings,
        component: SettingsPage,
        // authority: Permissions.setting_list,
      },
      {
				name: "basicInfo1",
				icon: <i className="ant-menu-item-icon fa fa-chalkboard-teacher" />,
				title: `${Resources.basicInfo}`,
				childs: [
          {
            name: "userJobs",
            icon: <AppstoreOutlined />,
            path: "/userJobs",
            title: Resources.userJobs,
            component: UserJobs,
          },
          {
            name: "PRType",
            icon: <ShoppingOutlined />,
            path: "/PRType",
            title: Resources.productRelationTypes,
            component: PRType,
          },
          // {
          //   name: "colors",
          //   icon: <SettingOutlined />,
          //   path: "/colors",
          //   title: Resources.colors,
          //   component: Color,
          //   // authority: Permissions.setting_list,
          // },
          // {
          //   name: "size",
          //   icon: <SettingOutlined />,
          //   path: "/size",
          //   title: Resources.sizes,
          //   component: Size,
          //   // authority: Permissions.setting_list,
          // },
          {
            name: "slider",
            icon: <AppstoreOutlined />,
            path: "/slider",
            title: Resources.slider,
            component: Slider,
          },
          {
            name: "socialNetworks",
            icon: <AppstoreOutlined />,
            path: "/socialNetworks",
            title: Resources.socialNetworks,
            component: SocialNetwork,
          },
        ]
      }
      // {
      //   name: "appDownload",
      //   icon: <SettingOutlined />,
      //   path: "/download-app",
      //   title: "مدیریت اپلیکیشن",
      //   component: AppDownloadManagement,
      //   authority: Permissions.setting_list,
      // },
    ],
  },
];
